/* Nubelle — fecha de entrega calculada.
   «Llega entre el lun 10 y el vie 14» es una promesa comprobable;
   «10 a 18 días hábiles» obliga a la clienta a hacer la cuenta.

   Rellena todo [data-nbl-eta] de la página:
     from  → "mié 13 de agosto"      to → igual, con el máximo
     short → "mié 13–17 ago"         ship → "jue 6"  (salida de almacén, 2 días)
   Config global en window.NBL (la escribe theme.liquid desde los ajustes).
*/
(function () {
  'use strict';

  var DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var MESES = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];

  function bizDays(n, from) {
    var d = new Date(from || Date.now());
    var left = Math.max(1, Math.round(n));
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) left--;
    }
    return d;
  }

  function longDay(d) {
    return DIAS[d.getDay()] + ' ' + d.getDate() + ' de ' + MESES[d.getMonth()];
  }

  function range(a, b) {
    var head = DIAS[a.getDay()] + ' ' + a.getDate();
    // Con una ventana de 10 a 18 días hábiles el rango cruza de mes casi
    // siempre. Sin el mes de salida, «jue 20–1 sep» se lee al revés.
    if (a.getMonth() !== b.getMonth()) head += ' ' + MESES[a.getMonth()].slice(0, 3);
    return head + '–' + b.getDate() + ' ' + MESES[b.getMonth()].slice(0, 3);
  }

  function shortDay(d) {
    return DIAS[d.getDay()] + ' ' + d.getDate();
  }

  function paint(root) {
    var cfg = window.NBL || {};
    var min = Number(cfg.shipMin) || 10;
    var max = Math.max(min, Number(cfg.shipMax) || 18);
    var from = bizDays(min);
    var to = bizDays(max);
    var ship = bizDays(2);
    var values = {
      from: longDay(from),
      to: longDay(to),
      short: range(from, to),
      ship: shortDay(ship)
    };

    (root || document).querySelectorAll('[data-nbl-eta]').forEach(function (el) {
      var value = values[el.getAttribute('data-nbl-eta')];
      if (value) el.textContent = value;
    });
  }

  window.NblEta = { bizDays: bizDays, longDay: longDay, range: range, shortDay: shortDay, paint: paint };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paint(); });
  } else {
    paint();
  }

  // Comprobación: añade ?nbltest a la URL y mira la consola.
  if (location.search.indexOf('nbltest') !== -1) {
    var vie = new Date(2026, 7, 7); // viernes 7 de agosto de 2026
    var ok = function (cond, msg) { console[cond ? 'log' : 'error']((cond ? 'OK  ' : 'FALLA ') + msg); };
    ok(bizDays(1, vie).getDate() === 10, '1 día hábil desde viernes salta el fin de semana → lunes 10');
    ok(bizDays(5, vie).getDate() === 14, '5 días hábiles desde viernes → viernes 14');
    ok(bizDays(0, vie).getDate() === 10, '0 se trata como 1 día mínimo');
    ok(longDay(new Date(2026, 7, 13)) === 'jue 13 de agosto', 'formato largo');
    ok(range(new Date(2026, 7, 13), new Date(2026, 7, 17)) === 'jue 13–17 ago', 'formato corto');
    ok(range(new Date(2026, 7, 20), new Date(2026, 8, 1)) === 'jue 20 ago–1 sep', 'formato corto cruzando de mes');
    var jue = new Date(2026, 7, 6); // jueves 6 de agosto de 2026
    ok(longDay(bizDays(10, jue)) === 'jue 20 de agosto', '10 días hábiles desde el jue 6 ago → jue 20 ago');
    ok(longDay(bizDays(18, jue)) === 'mar 1 de septiembre', '18 días hábiles desde el jue 6 ago → mar 1 sep');
  }
})();
